/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { userSessionIssuersGetAttachImpact } from "../funcs/userSessionIssuersGetAttachImpact.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { UserSessionIssuerAttachImpact } from "../models/components/usersessionissuerattachimpact.js";
import {
  GetUserSessionIssuerAttachImpactRequest,
  GetUserSessionIssuerAttachImpactSecurity,
} from "../models/operations/getusersessionissuerattachimpact.js";
import { unwrapAsync } from "../types/fp.js";
export type UserSessionIssuerAttachImpactQueryData =
  UserSessionIssuerAttachImpact;

export function prefetchUserSessionIssuerAttachImpact(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetUserSessionIssuerAttachImpactRequest | undefined,
  security?: GetUserSessionIssuerAttachImpactSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildUserSessionIssuerAttachImpactQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildUserSessionIssuerAttachImpactQuery(
  client$: GramCore,
  request?: GetUserSessionIssuerAttachImpactRequest | undefined,
  security?: GetUserSessionIssuerAttachImpactSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<UserSessionIssuerAttachImpactQueryData>;
} {
  return {
    queryKey: queryKeyUserSessionIssuerAttachImpact({
      mcpServerId: request?.mcpServerId,
      toolsetId: request?.toolsetId,
      metaMcpServerId: request?.metaMcpServerId,
      userSessionIssuerId: request?.userSessionIssuerId,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function userSessionIssuerAttachImpactQueryFn(
      ctx,
    ): Promise<UserSessionIssuerAttachImpactQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(userSessionIssuersGetAttachImpact(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyUserSessionIssuerAttachImpact(
  parameters: {
    mcpServerId?: string | undefined;
    toolsetId?: string | undefined;
    metaMcpServerId?: string | undefined;
    userSessionIssuerId?: string | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "userSessionIssuers", "getAttachImpact", parameters];
}
